import RUM from './cloudwatch-rum.js';
import StaticAssets from './static-assets';
import ReturnToDomains from './return-to-domain-names';
import about from './about';
import login from './login';

let config = {
    RUM: RUM,
    staticAssets: StaticAssets,
    allowedReturnToDomains: ReturnToDomains,
    about: about,
    login: login,
};

export default config;
